<script setup>
import {computed, onBeforeUnmount, onMounted, reactive, ref} from "vue";
import {HasPermission} from "@/utils/permisshoinHelper";
import Dialog from "primevue/dialog";
import PermissionsV1 from "@/router/permissions/v1";
import {useI18n} from "vue-i18n";
import {SendReserveStatsToOpenData} from "@/services/reserve";
import {ToastTimeoutMS} from "@/utils/constants";
import {useToast} from "primevue/usetoast";

const can = computed(() => [
  HasPermission(PermissionsV1['STATISTICS.OPEN_DATA.RESERVE.SEND_STATS']),
].includes(true));

const {t} = useI18n()
const toast = useToast();
const dialogState = ref(false)

const listener = (event) => {
  if (!can.value) return;

  const isKey = event.ctrlKey && event.altKey && event.keyCode === 71;

  if (!isKey) return;
  event.preventDefault();
  dialogState.value = !dialogState.value;
}

onMounted(() => {
  window.addEventListener('keydown', listener);
})
onBeforeUnmount(() => {
  window.removeEventListener('keydown', listener);
})

const loads = reactive({});
const isLoading = (index) => {
  return loads[index];
}

const sendReserveStatsToOpenData = (type) => {
  return SendReserveStatsToOpenData(type);
}

const actions = computed(() => [
  {
    title: t('send_reserve_stats_to_open_data'),
    access: () => HasPermission(PermissionsV1['STATISTICS.OPEN_DATA.RESERVE.SEND_STATS']),
    children: [
      {
        title: t('send_reserve_stats_to_open_data_n', {n: 'NRK'}),
        access: () => HasPermission(PermissionsV1['STATISTICS.OPEN_DATA.RESERVE.SEND_STATS']),
        action: () => sendReserveStatsToOpenData('nrk')
      },
      {
        title: t('send_reserve_stats_to_open_data_n', {n: 'MRK'}),
        access: () => HasPermission(PermissionsV1['STATISTICS.OPEN_DATA.RESERVE.SEND_STATS']),
        action: () => sendReserveStatsToOpenData('mrk')
      },
      {
        title: t('send_reserve_stats_to_open_data_n', {n: 'RRK'}),
        access: () => HasPermission(PermissionsV1['STATISTICS.OPEN_DATA.RESERVE.SEND_STATS']),
        action: () => sendReserveStatsToOpenData('rrk')
      },
    ],
    action: () => sendReserveStatsToOpenData('all')
  }
]);
const actionProxy = async (index, callback, access) => {
  if (isLoading(index) || !access()) return;
  loads[index] = true;
  try {
    await callback();

    await toast.add({
      severity: "success",
      summary: t("success"),
      detail: t("success_ran"),
      life: ToastTimeoutMS,
    });
  } finally {
    delete loads[index];
  }
}

</script>

<template>
  <template v-if="can">
    <Dialog v-model:visible="dialogState" :header="t('run')" class="w-[700px]" modal>
      <ul>
        <li v-for="(action, aI) in actions" :key="aI">
          <span
              :class="{'cursor-pointer': action.access()}"
              @click.prevent="actionProxy(aI, action.action, action.access)"
          >
            {{ action.title }}
            <template v-if="isLoading(aI)">
              <i class="pi pi-spin pi-spinner"/>
            </template>
          </span>
          <template v-if="action.children && action.children.length">
            <ul>
              <li v-for="(actionChild, aCI) in action.children" :key="aCI">
                <span
                    :class="{'cursor-pointer': actionChild.access()}"
                    @click.prevent="actionProxy(`${aI}:${aCI}`, actionChild.action, actionChild.access)"
                >
                  {{ actionChild.title }}
                  <template v-if="isLoading(`${aI}:${aCI}`)">
                    <i class="pi pi-spin pi-spinner"/>
                  </template>
                </span>
              </li>
            </ul>
          </template>
        </li>
      </ul>
    </Dialog>
  </template>
</template>

<style scoped>

</style>